<script lang="ts">
	/**
	 * `/Account/Subscription/:uuid` while it loads: the status panel and the invoices table in the
	 * two-thirds column, the manage panel beside them — the page's own `lg:grid-cols-3`.
	 */
	import Bone from './Bone.svelte';
</script>

<div role="status" aria-label="Loading the subscription" class="animate-pulse">
	<Bone class="h-8 w-64 mb-8" />
	<div class="grid gap-6 lg:grid-cols-3 items-start">
		<div class="lg:col-span-2 space-y-6">
			<div class="widget bg-depth space-y-4">
				<div class="flex items-center justify-between">
					<Bone class="h-4 w-24" />
					<Bone class="h-5 w-20" />
				</div>
				<div class="grid gap-3 sm:grid-cols-2">
					{#each Array(4) as _field, index (index)}
						<div class="space-y-2">
							<Bone class="h-2.5 w-20" />
							<Bone class="h-3 w-32" />
						</div>
					{/each}
				</div>
			</div>
			<div class="widget bg-depth space-y-3">
				<Bone class="h-4 w-24" />
				{#each Array(4) as _row, index (index)}
					<div class="grid grid-cols-4 gap-4">
						<Bone class="h-3 w-3/4" />
						<Bone class="h-3 w-1/2" />
						<Bone class="h-3 w-1/2" />
						<Bone class="h-3 w-2/3" />
					</div>
				{/each}
			</div>
		</div>
		<div class="widget bg-depth space-y-3">
			<Bone class="h-4 w-28" />
			<Bone class="h-9 w-full" round="xl" />
			<Bone class="h-9 w-full" round="xl" />
			<Bone class="h-9 w-full" round="xl" />
		</div>
	</div>
	<span class="sr-only">Loading…</span>
</div>
